import { gql } from '@apollo/client';
import {
    CYCLE_COUNT_FIELDS,
    CYCLE_COUNT_LOCATION_FIELDS,
    CYCLE_COUNT_SHIPPER_FIELDS,
} from '@/components/CycleCounts/graphql/fragments';

export const CYCLE_COUNT_BY_PK = gql`
    ${CYCLE_COUNT_FIELDS}
    ${CYCLE_COUNT_LOCATION_FIELDS}
    ${CYCLE_COUNT_SHIPPER_FIELDS}
    query CycleCountByPk($cycle_count_id: uuid!) {
        cycle_counts_by_pk(cycle_count_id: $cycle_count_id) {
            ...CycleCountFields
            warehouse {
                location_id
                location_name
                warehouse_racks
            }
            assigned_teammate {
                teammate_id
                username
            }
            template {
                cycle_count_template_id
                name
            }
            count_locations(order_by: { warehouse_location: asc }) {
                ...CycleCountLocationFields
            }
            shippers {
                ...CycleCountShipperFields
                shipper {
                    client_id
                    business_name
                }
            }
        }
    }
`;

export const CYCLE_COUNT_WAREHOUSE_ITEMS = gql`
    query CycleCountWarehouseItems($warehouse_id: uuid!) {
        items(
            where: {
                pallet: {
                    warehouse_id: { _eq: $warehouse_id }
                    warehouse_location: { _is_null: false }
                }
            }
        ) {
            item_id
            pallet {
                pallet_id
                warehouse_id
                warehouse_location
            }
        }
    }
`;
